import { useEffect, useState } from 'react';

// @Utility
import setBodyScroll from "@utility/app/setBodyScroll";

// Redux & Action
import { useDispatch } from 'react-redux';
import { openPromotionPopup } from "@core/redux/actions/promotion/index";

// Component
import Grid from '@mui/material/Grid';
import ModalApp from "views/components/ModalFull";

// Style & CSS
import "assets/css/Promotion.css";

const PromotionPopup = (props) => {
    const dispatch = useDispatch();
    const [dialogJson, setDialogJson] = useState(null);

    const onShow = (val) => {
        dispatch(openPromotionPopup({ ...props.reduxPromotionPopup, show: val }));
    };

    const selectPromotionData = (status) => {
        setBodyScroll(false);

        if (status) {
            dispatch(openPromotionPopup({ ...props.reduxPromotionPopup, show: false, promotionSelect: status }));
        }
        else {
            dispatch(openPromotionPopup({
                tab: "promotionPopup",
                promotionId: 0,
                promotionData: null,
                show: false,
                promotionSelect: status
            }));
        }
    };

    useEffect(() => {
        setDialogJson(props.reduxPromotionPopup.promotionData);
    }, [props]);

    return (
        <ModalApp show={props.reduxPromotionPopup.show} onShow={onShow}>
            <div className="boxContentScroll">
                <div className="promoitonDetail" style={{ padding: "0px" }}>
                    <div className="promoitonDetailTitle textBoldMedium center">
                        {
                            props.reduxPromotionPopup.promotionId !== 0 && props.reduxPromotionPopup.promotionId !== null ?
                            "รายละเอียดโปรโมชั่น"
                            :
                            "เงื่อนไขโปรโมชั่น"
                        }
                    </div>

                    <div className="boxMarginTop">
                        <div dangerouslySetInnerHTML={{ __html: dialogJson?.content_text }}></div>
                    </div>
                </div>
            </div>

            {
                props.reduxPromotionPopup.promotionId !== 0 && props.reduxPromotionPopup.promotionId !== null && (
                    <>
                        <br /><br />
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={6}>
                                <div className="btn btnDanger btnHover btnWidthFull btnRadius textBoldHight" onClick={() => { selectPromotionData(false) }}>
                                    ยกเลิกรับโปรโมชั่น
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <div className="btn btnConfirm btnHover btnWidthFull btnRadius textBoldHight" onClick={() => { selectPromotionData(true) }}>
                                    รับโปรโมชั่น
                                </div>
                            </Grid>
                        </Grid>
                    </>
                )
            }
        </ModalApp>
    );
}

export default PromotionPopup;